import { render, staticRenderFns } from "./AppRanking.vue?vue&type=template&id=24f30ac4&"
import script from "./AppRanking.vue?vue&type=script&lang=js&"
export * from "./AppRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports